import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import type {
  AddDraftRowAction,
  DeleteRowAction,
  EditRowAction,
  ResetDraftRowAction,
  SaveDraftRowAction,
  TableState,
  UpdateDraftRowAction,
} from '@/redux/slices/table/types';

const initialState: TableState = {
  data: [],
  draftData: {},
  editableRows: {},
};

const tableSlice = createSlice({
  name: 'table',
  initialState,
  reducers: {
    addDraftRow: (state, action: PayloadAction<AddDraftRowAction>) => {
      const { rowIndex, data } = action.payload;
      state.data[rowIndex] = data;
      state.draftData[rowIndex] = data;
      state.editableRows[rowIndex] = true;
    },
    updateDraftRow: (state, action: PayloadAction<UpdateDraftRowAction>) => {
      const { rowIndex, data } = action.payload;
      state.draftData[rowIndex] = { ...state.draftData[rowIndex], ...data };
    },
    saveDraftRow: (state, action: PayloadAction<SaveDraftRowAction>) => {
      const { rowIndex } = action.payload;
      state.data[rowIndex] = state.draftData[rowIndex];
      delete state.draftData[rowIndex];
      delete state.editableRows[rowIndex];
    },
    resetDraftRow: (state, action: PayloadAction<ResetDraftRowAction>) => {
      const { rowIndex } = action.payload;
      delete state.draftData[rowIndex];
      delete state.editableRows[rowIndex];
    },
    editRow: (state, action: PayloadAction<EditRowAction>) => {
      const { rowIndex } = action.payload;
      state.draftData[rowIndex] = { ...state.data[rowIndex] };
      state.editableRows[rowIndex] = true;
    },
    deleteRow: (state, action: PayloadAction<DeleteRowAction>) => {
      const { rowIndex } = action.payload;
      state.data.splice(rowIndex, 1);
      delete state.draftData[rowIndex];
      delete state.editableRows[rowIndex];
    },
  },
});

// actions
export const { addDraftRow, updateDraftRow, saveDraftRow, resetDraftRow, editRow, deleteRow } = tableSlice.actions;

// reducer
export default tableSlice.reducer;
